import PLACEHOLDER_LOGO from '@/assets/images/logo/weee-placeholder-logo.png';

export default function BannerThemeSkeleton() {
  return (
    <div className="h-[155px] w-full">
      <div
        className="w-full h-full"
        style={{
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundImage: `url(${PLACEHOLDER_LOGO})`,
          backgroundSize: '105px 31.5px'
        }}
      />
    </div>
  );
}
